import {
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  output,
  signal,
} from '@angular/core';

@Directive({
  selector: '[siatStickyObserver]',
   
  host: {
    '[class.is-sticky]': 'isSticky()',
  },
})
export class StickyObserverDirective {
  /**
   * It returns true if the element is sticky
   */
  isSticky = signal(false);

  /**
   * It emits true if the element is sticky
   */
  stickyChange = output<boolean>();

  /**
   * The element to observe.
   */
  private el = inject(ElementRef);

  constructor() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const sticky = !entry.isIntersecting;
        this.isSticky.set(sticky);
        this.stickyChange.emit(sticky);
      },
      {
        rootMargin: '-65px 0px 0px 0px',
        threshold: [1],
      }
    );

    observer.observe(this.el.nativeElement);

    inject(DestroyRef).onDestroy(() => observer.disconnect());
  }
}
